export default "__VITE_ASSET__$_Bs4Csc__"